<template>
  <NavbarOne />
  <PageBanner
    pageTitle="خدماتنا"
    subTitle="استكشف خدمات IPTV المتكاملة واستمتع بآلاف القنوات العربية والعالمية، الأفلام، المسلسلات، والبث المباشر بجودة HD و4K."
    :pageBannerImage="pageBannerImg"
  />
  <OurServices />
  <PricingPlans />
  <TestOurService />
  <FAQ />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import OurServices from "@/components/Services/OurServices.vue";
import PricingPlans from "@/components/Services/PricingPlans.vue";
import TestOurService from "@/components/Services/TestOurService.vue";
import FAQ from "@/components/Services/FAQ.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ServicesPage",
  components: {
    NavbarOne,
    PageBanner,
    OurServices,
    PricingPlans,
    TestOurService,
    FAQ,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "خدمات IPTV | قنوات مباشرة وأفلام ومسلسلات بجودة 4K",
      meta: [
        {
          name: "description",
          content:
            "تعرف على خدمات IPTV المتوفرة، بما في ذلك القنوات العربية والعالمية، القنوات الرياضية، الأفلام، المسلسلات، والمحتوى حسب الطلب مع جودة HD و4K ودعم جميع الأجهزة.",
        },
        {
          name: "keywords",
          content:
            "خدمات IPTV, اشتراك IPTV, IPTV 4K, IPTV HD, قنوات عربية, قنوات رياضية, أفلام, مسلسلات, VOD, Smart TV",
        },
        {
          property: "og:title",
          content: "خدمات IPTV | قنوات مباشرة وأفلام ومسلسلات",
        },
        {
          property: "og:description",
          content:
            "استكشف جميع خدمات IPTV المتوفرة واستمتع بتجربة مشاهدة متكاملة بجودة عالية وثبات ممتاز.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/services",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-2.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>